<template>
  <CookieDisclaimer :config="config" />
</template>

<script>
import CookieDisclaimer from "../../components/CookieDisclaimer/CookieDisclaimer.vue";

export default {
  name: "app",
  components: {
    CookieDisclaimer
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
